import { request } from "./http";

export interface IbRule {
  id: string;
  account_group_id: string | null;
  spread_share_pct: string;
  commission_share_pct: string;
  flat_per_lot: string;
  currency: string;
  enabled: boolean;
  created_at: string | null;
}

export interface IbRuleCreate {
  account_group_id?: string | null;
  spread_share_pct?: string | number;
  commission_share_pct?: string | number;
  flat_per_lot?: string | number;
  currency?: string;
  enabled?: boolean;
}

export interface IbPayout {
  id: string;
  ib_user_id: string;
  period_start: string | null;
  period_end: string | null;
  currency: string;
  amount: string;
  referred_lot_volume: string;
  referred_user_count: number;
  status: "PENDING" | "APPROVED" | "PAID";
  paid_at: string | null;
  payment_reference: string | null;
  created_at: string | null;
}

export interface Referral {
  id: string;
  referrer_user_id: string;
  referred_user_id: string;
  referred_at: string | null;
}

export const ib = {
  listRules: () => request<IbRule[]>("/api/v1/admin/ib/rules"),
  createRule: (body: IbRuleCreate) => request<IbRule>("/api/v1/admin/ib/rules", { body }),
  patchRule: (id: string, body: Partial<IbRuleCreate>) =>
    request<IbRule>(`/api/v1/admin/ib/rules/${id}`, { method: "PATCH", body }),
  listPayouts: (status?: string) =>
    request<IbPayout[]>(`/api/v1/admin/ib/payouts${status ? `?status=${status}` : ""}`),
  approvePayout: (id: string) =>
    request<{ status: string }>(`/api/v1/admin/ib/payouts/${id}/approve`, { body: {} }),
  markPayoutPaid: (id: string, payment_reference?: string) =>
    request<{ status: string }>(`/api/v1/admin/ib/payouts/${id}/mark-paid`, {
      body: { payment_reference },
    }),
  listReferrals: () => request<Referral[]>("/api/v1/admin/ib/referrals"),
};
